import { Link } from 'react-router-dom';
import { useDailyPrompt } from '@/hooks/useDailyPrompt';
import { Sparkles, ArrowRight } from 'lucide-react';

interface DailyPromptCardProps {
  className?: string;
}

const DailyPromptCard = ({ className = '' }: DailyPromptCardProps) => {
  const { prompt, suggestedRoom } = useDailyPrompt();

  if (!suggestedRoom) return null;

  return (
    <div className={`relative overflow-hidden ${className}`}>
      <div className="p-6 border border-border/30 bg-gradient-to-br from-muted/20 to-transparent hover:border-border/50 transition-all duration-500 group">
        <div className="flex items-start gap-4">
          <Sparkles className="w-4 h-4 text-muted-foreground/50 mt-1 flex-shrink-0" />
          <div className="flex-1 min-w-0">
            <p className="text-foreground/80 text-sm font-light italic mb-4 leading-relaxed">
              "{prompt}"
            </p>
            <Link
              to={suggestedRoom.path}
              className="inline-flex items-center gap-2 text-xs text-muted-foreground/60 hover:text-foreground transition-colors group/link"
            >
              <span>Enter: {suggestedRoom.title}</span>
              <ArrowRight className="w-3 h-3 group-hover/link:translate-x-1 transition-transform" />
            </Link>
          </div>
        </div>
      </div>
      
      {/* Subtle shimmer effect */}
      <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-700 pointer-events-none">
        <div className="absolute inset-0 animate-shimmer" />
      </div>
    </div>
  );
};

export default DailyPromptCard;
